import React from 'react';
import { useTranslation } from 'react-i18next';
import './FilterTabs.css';

const FilterTabs = ({
  tabs = [],
  activeTab,
  onTabChange,
  className = '',
  defaultNs = 'documents',
}) => {
  const { i18n } = useTranslation();

  const resolveLabel = (tab) => {
    if (tab.labelKey) {
      return i18n.t(`${tab.ns || defaultNs}:${tab.labelKey}`);
    }
    return tab.label ?? '';
  };

  return (
    <div className={`filter-tabs-container ${className}`} key={i18n.language}>
      {tabs.map((tab, index) => {
        const label = resolveLabel(tab);
        const tabId = tab.key || tab.value || index;
        return (
          <button
            key={tabId}
            type="button"
            onClick={() => onTabChange(tab.value || tab.key)}
            className={`filter-tab ${activeTab === (tab.value || tab.key) ? 'filter-tab--active' : 'filter-tab--inactive'}`}
          >
            {tab.count !== undefined && tab.count !== null
              ? `${label} (${tab.count})`
              : label}
          </button>
        );
      })}
    </div>
  );
};

export default FilterTabs; 